// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","379":"1bfc9850"}[chunkId] + "-" + {"293":"6441bbee08f13a88a595","379":"e32d249c8911d306f69c"}[chunkId] + ".js";
};